import React from 'react';
import styled from 'styled-components';

import { ActionsSpecs } from 'src/presentation/components/pages/sidekick/threads/SidekickActionsConstants';
import AddSubActionButton from './AddSubActionButton';
import { Section } from 'src/presentation/components/forms/Layout';
import SidekickModuleSpec, { ModifierSpec } from 'src/models/Sidekick/SidekickModuleSpec';

type SidePanelHeaderProps = {
  isModule?: boolean;
  spec: SidekickModuleSpec | ModifierSpec;
};

export default function SidePanelHeader({ isModule, spec }: SidePanelHeaderProps) {
  let description = ActionsSpecs[spec.name]?.presentableDescription;
  let name = ActionsSpecs[spec.name]?.presentableName;

  if (!description) {
    const html = { __html: spec.presentableDescription };
    description = spec.presentableDescription ? <span dangerouslySetInnerHTML={html} /> : null;
  }

  if (!name) {
    name = spec.presentableName || spec.name;
  }

  const showAddSubActionButton = isModule && !spec?.controlCategories && !spec?.integrations;

  return (
    <StyledSection id="action-panel" header={name} description={description}>
      {showAddSubActionButton && <AddSubActionButton />}
    </StyledSection>
  );
}

const StyledSection = styled(Section)`
  margin-bottom: 0;
`;
